// @flow
import type { Day } from 'types/index'
import { weekDays } from 'constants/roster'

export const getNextWeekDay = (day: Day): Day => {
  if(day === 'su') return 'mo'
  return weekDays[ weekDays.indexOf(day) + 1]
}

export const getPrevWeekDay = (day: Day): Day => {
  if(day === 'mo') return 'su'
  return weekDays[ weekDays.indexOf(day) - 1]
}



// WEBPACK FOOTER //
// ./src/containers/mob/topbarMobile/dateSelect/daySelect/localHelpers.js